<template>
  <v-footer height="auto" position="absolute">
    <v-layout
      id="footerBody"
      class="footer-admin"
      align-center
      justify-space-between
      row
      fill-height
      px-3
      py-2
    >
      <v-flex row sm12 mb-sm-3 md4 mb-md-0 lg4 ml-0 mr-0 justify-start class="footerItem">
        <div class="mr-2">
          <img
            class="footer-icon-left"
            width="40px"
            src="../assets/icon-techsupport.png"
            alt="computer icon"
          />
        </div>
        <div class="footer-text-left">
          <h4>Technical Support</h4>
          <p>
            <a href="mailto:NCSES-FedFundsSurvey@nsf.gov">NCSES-FedFundsSurvey@nsf.gov</a>
          </p>
          <p>(703) 312-5379 &nbsp;&nbsp;|&nbsp;&nbsp; Help Desk Hours: 9 am – 5 pm, Mon-Fri ET</p>
        </div>
      </v-flex>
      <v-flex row sm12 mb-sm-3 md4 mb-md-0 lg4 ml-0 mr-0 justify-start class="footerItem">
        <div class="pl-lg-3 mr-2">
          <img
            class="footer-icon-left"
            width="40px"
            src="../assets/icon-questions.png"
            alt="pencil icon"
          />
        </div>
        <div class="footer-text-middle">
          <h4>General Survey Questions</h4>
          <p>Christopher Pece, National Center for Science and Engineering Statistics, NSF</p>
          <p>
            <a href="mailto:cpece@nsf.gov">cpece@nsf.gov</a>&nbsp;&nbsp;|&nbsp;&nbsp;(703) 292-7788
          </p>
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex sm12 md4 lg4 class="footer-right">
        <div class="d-flex justify-space-around mb-1">
          <div class>
            <img class="type-img" src="../assets/agency.png" alt="Agency icon" />
            <span>Agency</span>
          </div>
          <div>
            <img class="type-img" src="../assets/program.png" alt="Program Office icon" />
            <span>Program office</span>
          </div>
          <div class>
            <img class="type-img" src="../assets/field.png" alt="Field Office icon" />
            <span>Field office</span>
          </div>
          <div class>
            <img class="type-img" src="../assets/branch.png" alt="Branch Office icon" />
            <span>Branch office</span>
          </div>
        </div>
        <div class="text-right">&copy; 2020 National Science Foundation</div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: "FooterAdmin"
};
</script>

<style scoped>
#footerBody {
  padding-left: 16px !important; /* both needed to deal w/differing padding on Survey vs Landing pages */
  padding-right: 16px !important;
}

.footerItem {
  flex-wrap: nowrap;
  text-align: left;
}

.footerItem:first-child {
  border-right: 1px solid #9dc4d1;
}

.v-footer {
  border-top: 1px solid #ffffff !important;
  border-bottom: 1px solid #ffffff !important;
  background-color: #ffffff !important;
  font-size: 9pt;
}

.v-footer h4 {
  font-size: 10pt;
  margin-bottom: 4px;
  font-weight: bold;
}
.v-footer p {
  margin: 0;
}

.v-footer a {
  color: #125289 !important; /* 508 AAA > 7 */
}

.footer-icon-left {
  margin-right: 10px;
}
.footer-icon-middle {
  margin-top: 0px;
}
.footer-text-left {
  padding-right: 15px;
}

.footer-right {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-right span {
  margin-left: 5px;
}

.type-img {
  width: 24px;
}

@media (max-width: 1280) {
  .footer-right span {
  }
}

@media (max-width: 960px) {
  .footerItem:first-child {
    border-right: none;
  }
}
</style>
